//@flow
import * as React from "react";
import styled from "react-emotion";
import { theme, mqMin, AbsOverflow } from "../../styles/theme";
import MenuWrap from "../MenuWrap";

const Screen = styled.div`
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-wrap: none;
  justify-content: center;
  align-items: center;
  padding-left: ${theme.space1};
  padding-right: ${theme.space1};
  padding-top: ${theme.space3};
  padding-bottom: ${theme.space3};

  ${mqMin(theme.desktop)} {
    margin-left: auto;
    margin-right: auto;
    padding-top: ${theme.space1};
    padding-bottom: ${theme.space1};
    max-width: ${theme.maxWidth3};
  }
`;
const Text = styled.h2`
  font-family: ${theme.sans.fontFamily};
  font-weight: ${theme.sans.bold};
  font-size: ${theme.h1};
  line-height: ${theme.lineHeight3};
  ${mqMin(theme.tablet)} {
    font-size: ${theme.super};
    line-height: ${theme.lineHeight1};
  }
`;
const Heading = styled.h3`
  font-size: ${theme.h3};
  font-family: ${theme.heading.fontFamily};
  font-weight: ${theme.heading.normal};
  line-height: ${theme.lineHeight1};
  margin-bottom: ${theme.space1};
  ${mqMin(theme.tablet)} {
    font-size: ${theme.h2};
  }
`;

const MobileBlock = styled.div`
  display: block;
  margin-bottom: ${theme.space1};
  ${mqMin(theme.tablet)} {
    display: inline;
  }
`;
const HideMobile = styled.span`
  display: none;
  ${mqMin(theme.tablet)} {
    display: initial;
  }
`;

const DotBreak = () => (
  <MobileBlock>
    <HideMobile> • </HideMobile>
  </MobileBlock>
);

const Media = ({ page, heading = "We Do", open }) => {
  return (
    <MenuWrap x={100} open="MEDIA">
      <Screen>
        <div>
          <Heading>{heading}</Heading>
          <Text>
            GRAPHIC DESIGN<DotBreak />WEBSITE DEVELOPMENT<DotBreak />PHOTOGRAPHY<DotBreak />DRONE
            FOOTAGE<DotBreak />
            VIDEO PRODUCTION<DotBreak />PRINT ADVERTISING<DotBreak />COPYWRITING<DotBreak />SOCIAL
            MEDIA
          </Text>
        </div>
      </Screen>
    </MenuWrap>
  );
};

export default Media;



// WEBPACK FOOTER //
// ./src/components/Media/index.js